// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type AccountAuthenticationTabQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type AccountAuthenticationTabQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id' | 'only_sso_login'>
      & { features: (
        { __typename?: 'OrganisationFeatures' }
        & Pick<PrivateSchemaTypes.OrganisationFeatures, 'account_name_login'>
      ) }
    )> }
  )> }
);

export type GetCalendarIntegrationsForOrganisationQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type GetCalendarIntegrationsForOrganisationQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id' | 'authUrlForMSGraphCalendarIntegration'>
      & { calendars: (
        { __typename?: 'OrganisationCalendars' }
        & { msgraph?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'MSGraphCalendarConfig' }
          & Pick<PrivateSchemaTypes.MsGraphCalendarConfig, 'accountName'>
        )>, google?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'GoogleCalendarConfigPublic' }
          & Pick<PrivateSchemaTypes.GoogleCalendarConfigPublic, 'calendarId'>
        )> }
      ) }
    )> }
  )> }
);

export type SetCalendarIdMutationVariables = PrivateSchemaTypes.Exact<{
  calendarId: PrivateSchemaTypes.Scalars['String'];
}>;


export type SetCalendarIdMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'setGoogleCalendarIdForOrganisation'>
    )> }
  )> }
);

export type SetMsCalendarIntegrationMutationVariables = PrivateSchemaTypes.Exact<{
  authCode: PrivateSchemaTypes.Scalars['String'];
}>;


export type SetMsCalendarIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & { setupMSGraphCalendarIntegrationForOrganisation?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'OrganisationModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      )> }
    )> }
  )> }
);

export type RenewMsCalendarIntegrationMutationVariables = PrivateSchemaTypes.Exact<{
  authCode: PrivateSchemaTypes.Scalars['String'];
}>;


export type RenewMsCalendarIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & { renewMSGraphCalendarIntegrationCredentialsForOrganisation?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'OrganisationModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      )> }
    )> }
  )> }
);


export const AccountAuthenticationTabDocument = gql`
    query AccountAuthenticationTab {
  admin {
    organisation {
      id
      only_sso_login
      features {
        account_name_login
      }
    }
  }
}
    `;

/**
 * __useAccountAuthenticationTabQuery__
 *
 * To run a query within a React component, call `useAccountAuthenticationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountAuthenticationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountAuthenticationTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountAuthenticationTabQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountAuthenticationTabQuery, AccountAuthenticationTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountAuthenticationTabQuery, AccountAuthenticationTabQueryVariables>(AccountAuthenticationTabDocument, options);
      }
export function useAccountAuthenticationTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountAuthenticationTabQuery, AccountAuthenticationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountAuthenticationTabQuery, AccountAuthenticationTabQueryVariables>(AccountAuthenticationTabDocument, options);
        }
export type AccountAuthenticationTabQueryHookResult = ReturnType<typeof useAccountAuthenticationTabQuery>;
export type AccountAuthenticationTabLazyQueryHookResult = ReturnType<typeof useAccountAuthenticationTabLazyQuery>;
export type AccountAuthenticationTabQueryResult = Apollo.QueryResult<AccountAuthenticationTabQuery, AccountAuthenticationTabQueryVariables>;
export const GetCalendarIntegrationsForOrganisationDocument = gql`
    query getCalendarIntegrationsForOrganisation {
  admin {
    organisation {
      id
      authUrlForMSGraphCalendarIntegration
      calendars {
        msgraph {
          accountName
        }
        google {
          calendarId
        }
      }
    }
  }
}
    `;

/**
 * __useGetCalendarIntegrationsForOrganisationQuery__
 *
 * To run a query within a React component, call `useGetCalendarIntegrationsForOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarIntegrationsForOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarIntegrationsForOrganisationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCalendarIntegrationsForOrganisationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCalendarIntegrationsForOrganisationQuery, GetCalendarIntegrationsForOrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCalendarIntegrationsForOrganisationQuery, GetCalendarIntegrationsForOrganisationQueryVariables>(GetCalendarIntegrationsForOrganisationDocument, options);
      }
export function useGetCalendarIntegrationsForOrganisationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCalendarIntegrationsForOrganisationQuery, GetCalendarIntegrationsForOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCalendarIntegrationsForOrganisationQuery, GetCalendarIntegrationsForOrganisationQueryVariables>(GetCalendarIntegrationsForOrganisationDocument, options);
        }
export type GetCalendarIntegrationsForOrganisationQueryHookResult = ReturnType<typeof useGetCalendarIntegrationsForOrganisationQuery>;
export type GetCalendarIntegrationsForOrganisationLazyQueryHookResult = ReturnType<typeof useGetCalendarIntegrationsForOrganisationLazyQuery>;
export type GetCalendarIntegrationsForOrganisationQueryResult = Apollo.QueryResult<GetCalendarIntegrationsForOrganisationQuery, GetCalendarIntegrationsForOrganisationQueryVariables>;
export const SetCalendarIdDocument = gql`
    mutation setCalendarId($calendarId: String!) {
  admin {
    organisation {
      setGoogleCalendarIdForOrganisation(calendarId: $calendarId)
    }
  }
}
    `;
export type SetCalendarIdMutationFn = Apollo.MutationFunction<SetCalendarIdMutation, SetCalendarIdMutationVariables>;

/**
 * __useSetCalendarIdMutation__
 *
 * To run a mutation, you first call `useSetCalendarIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCalendarIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCalendarIdMutation, { data, loading, error }] = useSetCalendarIdMutation({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *   },
 * });
 */
export function useSetCalendarIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCalendarIdMutation, SetCalendarIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCalendarIdMutation, SetCalendarIdMutationVariables>(SetCalendarIdDocument, options);
      }
export type SetCalendarIdMutationHookResult = ReturnType<typeof useSetCalendarIdMutation>;
export type SetCalendarIdMutationResult = Apollo.MutationResult<SetCalendarIdMutation>;
export type SetCalendarIdMutationOptions = Apollo.BaseMutationOptions<SetCalendarIdMutation, SetCalendarIdMutationVariables>;
export const SetMsCalendarIntegrationDocument = gql`
    mutation setMSCalendarIntegration($authCode: String!) {
  admin {
    organisation {
      setupMSGraphCalendarIntegrationForOrganisation(authCode: $authCode) {
        id
      }
    }
  }
}
    `;
export type SetMsCalendarIntegrationMutationFn = Apollo.MutationFunction<SetMsCalendarIntegrationMutation, SetMsCalendarIntegrationMutationVariables>;

/**
 * __useSetMsCalendarIntegrationMutation__
 *
 * To run a mutation, you first call `useSetMsCalendarIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMsCalendarIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMsCalendarIntegrationMutation, { data, loading, error }] = useSetMsCalendarIntegrationMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *   },
 * });
 */
export function useSetMsCalendarIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMsCalendarIntegrationMutation, SetMsCalendarIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMsCalendarIntegrationMutation, SetMsCalendarIntegrationMutationVariables>(SetMsCalendarIntegrationDocument, options);
      }
export type SetMsCalendarIntegrationMutationHookResult = ReturnType<typeof useSetMsCalendarIntegrationMutation>;
export type SetMsCalendarIntegrationMutationResult = Apollo.MutationResult<SetMsCalendarIntegrationMutation>;
export type SetMsCalendarIntegrationMutationOptions = Apollo.BaseMutationOptions<SetMsCalendarIntegrationMutation, SetMsCalendarIntegrationMutationVariables>;
export const RenewMsCalendarIntegrationDocument = gql`
    mutation renewMSCalendarIntegration($authCode: String!) {
  admin {
    organisation {
      renewMSGraphCalendarIntegrationCredentialsForOrganisation(authCode: $authCode) {
        id
      }
    }
  }
}
    `;
export type RenewMsCalendarIntegrationMutationFn = Apollo.MutationFunction<RenewMsCalendarIntegrationMutation, RenewMsCalendarIntegrationMutationVariables>;

/**
 * __useRenewMsCalendarIntegrationMutation__
 *
 * To run a mutation, you first call `useRenewMsCalendarIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewMsCalendarIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewMsCalendarIntegrationMutation, { data, loading, error }] = useRenewMsCalendarIntegrationMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *   },
 * });
 */
export function useRenewMsCalendarIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenewMsCalendarIntegrationMutation, RenewMsCalendarIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenewMsCalendarIntegrationMutation, RenewMsCalendarIntegrationMutationVariables>(RenewMsCalendarIntegrationDocument, options);
      }
export type RenewMsCalendarIntegrationMutationHookResult = ReturnType<typeof useRenewMsCalendarIntegrationMutation>;
export type RenewMsCalendarIntegrationMutationResult = Apollo.MutationResult<RenewMsCalendarIntegrationMutation>;
export type RenewMsCalendarIntegrationMutationOptions = Apollo.BaseMutationOptions<RenewMsCalendarIntegrationMutation, RenewMsCalendarIntegrationMutationVariables>;